import React from 'react'
import { useTranslation } from 'react-i18next';
import { FormHelperText } from '@mui/material';
import Portal from '@mui/material/Portal';
import { Typography, TextField } from '@mui/material';
import { compareValidation } from '../../validators/compare';
import { useDispatch, useSelector } from 'react-redux';
import { addItemToCompareList } from '../../redux/reducers/comparesList.reducer';
import firebase from 'firebase';
import { Formik } from 'formik';
import { makeStyles } from "@mui/styles/";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { useTheme } from '@mui/material/styles';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { toast as Toast } from 'react-toastify';
const useStyles = makeStyles({
    form: {
        marginTop: 10
    },
    input: {
        marginTop: 5,
        marginBottom: 5,
    },

})
const SaveCartModal = ({ visible, hideDialog, userInfo, isAnonymous, title, body, confirmCb }) => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const [loading, setLoading] = React.useState(false);
    //const { userInfo , isAnonymous } = useAuthentication();
    const styles = useStyles();
    const theme = useTheme();
    const products = useSelector(state => state.cart.products);
    const handleSave = async (values, helpers) => {
        setLoading(true);
        if (!!userInfo?.id && !isAnonymous) {
            const docRef = await firebase.firestore().collection('users').doc(userInfo.id).collection('compares').doc();
            const compare = {
                id: docRef.id,
                title: values.title,
                products: products,
                count: products.length ?? 0
            }
            docRef.set(compare, { merge: true }).then(res => {
                Toast.success(
                    
                  'Comparing Saved Successfully!'
                )
                helpers.setSubmitting(false);
                dispatch(addItemToCompareList(compare));
                setLoading(false);
                hideDialog();
            }).catch(er => {
                console.log(er);
            setLoading(false);
                Toast.error(
                    
                    'Something went wrong :('
                )
                helpers.setSubmitting(false);
                setLoading(false);
                hideDialog();
            })
        }else if(isAnonymous){ 
            Toast.error(`Oops! \n\n ${t("users.loginAsNormalUser")}`);
            setLoading(false);
        }else { 
            Toast.error(`Oops! \n\n Something went wrong :(`);
            setLoading(false);
        }

    }
    return (
        <Portal style={{ width: '100%',}}>
            <Dialog open={visible} dismissable onClose={hideDialog} style={{ width: '100%', alignSelf: 'center',  marginRight: 5,
        marginLeft: 5, borderRadius: 10 }}>
                <DialogContent>
                    <div style={{ padding: 0, margin: 0 }}>
                        <Typography style={{ marginTop: 5,
        marginBottom: 5, textAlign: 'center' }}>{"Save Comparison"}</Typography>

                    </div>
                    <div className={styles.form}>
                        <Formik
                            initialValues={{
                                title: '',
                            }}
                            validationSchema={compareValidation}
                            onSubmit={(values, helpers) => {
                                handleSave(values, helpers);
                            }}
                            validateOnBlur
                        >
                            {
                                ({ handleChange, handleBlur, handleSubmit, values, errors, isValid, isSubmitting, setFieldValue }) => (
                                    <>
                                        <div className={styles.input}>
                                        <TextField
                    label={"Title"}
                    value={values.title}
                    onChange={handleChange('title')}
                    onBlur={handleBlur('title')}
                    autoCapitalize='none'
                    disabled={isSubmitting}
                    mode='outlined'
                    error={!!errors.title}
                    
                   // activeOutlineColor={customTheme.light.primary}
                  // outlineColor={customTheme.light.white}
                />
                                            {/* <TextInput
                                                label={"Arabic Title"}
                                                value={values.titleAr}
                                                onChangeText={handleChange('titleAr')}
                                                onBlur={handleBlur('titleAr')}
                                                autoCapitalize='none'
                                                disabled={isSubmitting}
                                                mode='outlined'
                                                error={!!errors.titleAr}
                                                activeOutlineColor={customTheme.light.primary}
                                                outlineColor={customTheme.light.white}
                                                left={<TextInput.Icon name={'label'} color={customTheme.light.primary} size={20} />}
                                            /> */}
                                            {
                                                errors.title && <FormHelperText  error={!!errors.title}>
                                                    {errors.title}
                                                </FormHelperText>
                                            }
                                        </div>
                                        <DialogActions>
                                            <Button disabled={loading} className={{ backgroundColor: theme.dark.secondary}} onClick={handleSubmit}>{"Save"}</Button>
                                            <Button disabled={loading} onClick={hideDialog}>{"cancel"}</Button>
                                        </DialogActions>
                                    </>)
                            }

                        </Formik>
                    </div>

                </DialogContent>

            </Dialog>
        </Portal>
    )
}

export default SaveCartModal;